import axios from 'axios'
import Vue from 'vue'
import AuthService from "@/service/AuthService";

export default class AgentService {
    authService = new AuthService();
    config = {
        headers: { Authorization: `Bearer ${this.authService.getUserBearerToken()}` }
    };
    getAgentProfile(agentId) {
        const data = {
            AgentId: agentId
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Agent/GetAgentInfo', data, this.config);
    }
    getAgentRoles(agentId) {
        const data = {
            AgentId: agentId
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Agent/GetAgentRoles', data, this.config);
    }
    getAgentProfileFromPlayer(playerId) {
        const data = {
            PlayerId: playerId
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Agent/GetAgentInfoFromPlayer', data, this.config);
    }
    getAgentAvatar(agentId) {
        const data = {
            AgentId: agentId
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Agent/GetAgentAvatar', data, this.config);
    }
    saveAgentProfile(agent) {
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Agent/SaveAgentInfo', agent, this.config);
    }
    addOrUpdatePlayer(agentId, player) {
        const data = {
            AgentId: agentId,
            Player: player
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Agent/AddOrUpdateAgentPlayer', data, this.config);
    }
    getPlayerList(agentId) {
        const data = {
            AgentId: agentId
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Agent/GetAgentPlayerList', data, this.config);
    }
    deletePlayer(playerId) {
        const data = {
            AgentPlayerId: playerId
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Agent/DeletePlayer', data, this.config);
    }
    updateAgentContacts(agentId, email, phone) {
        const data = {
            AgentId: agentId,
            Email: email,
            Phone: phone
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Agent/UpdateAgentContacts', data, this.config);
    }
    getAgentPlayerIdByName(agentId, playerName) {
        const data = {
            AgentId: agentId,
            PlayerName: playerName
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Agent/GetAgentPlayerIdByName', data, this.config);
    }
}